// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'team-member-payroll-adjustment.page.title': 'Payroll Adjustments',
    'team-member-payroll-adjustment.page.archive.title': 'Archived Payroll Adjustments',
    'team-member-payroll-adjustment.page.search_results': 'Search Results',
    'team-member-payroll-adjustment.page.create.title': 'Create New Payroll Adjustment',
    'team-member-payroll-adjustment.page.search.title': 'Find Payroll Adjustments',
    'team-member-payroll-adjustment.page.edit.title': 'Edit Payroll Adjustment',
    'team-member-payroll-adjustment.page.view.title': 'View Payroll Adjustment',
    'team-member-payroll-adjustment.page.all': 'All',

    'team-member-payroll-adjustment.button.cancel': 'Cancel',
    'team-member-payroll-adjustment.button.select': 'Select',
    'team-member-payroll-adjustment.button.find': 'Find Adjustments',
    'team-member-payroll-adjustment.button.search': 'Apply',
    'team-member-payroll-adjustment.button.create': 'Save Adjustment',
    'team-member-payroll-adjustment.button.new': 'New Adjustment',
    'team-member-payroll-adjustment.button.save': 'Save Changes',
    'team-member-payroll-adjustment.button.archive': 'Archive',
    'team-member-payroll-adjustment.button.delete': 'Permanently Delete',
    'team-member-payroll-adjustment.button.edit': 'Edit',
    'team-member-payroll-adjustment.button.restore': 'Restore',
    'team-member-payroll-adjustment.button.reset': 'Reset',

    'team-member-payroll-adjustment.placeholder.search': 'Search payroll adjustments',

    'team-member-payroll-adjustment.link.create_first_team_member_payroll_adjustment': 'Click here to create your first payroll adjustment',
    'team-member-payroll-adjustment.link.team_member_payroll_adjustments': ' Return to Payroll Adjustments',
    'team-member-payroll-adjustment.link.archive': 'Archived Payroll Adjustments',
    'team-member-payroll-adjustment.link.retry': 'Click here to retry',

    'team-member-payroll-adjustment.checkbox.all': 'Check All',
    'team-member-payroll-adjustment.checkbox.actions_label': 'with selected',

    'team-member-payroll-adjustment.label.team_member_name': 'Team Member',

    'team-member-payroll-adjustment.label.from__from_date': 'From from date',
    'team-member-payroll-adjustment.label.to__from_date': 'To from date',
    'team-member-payroll-adjustment.label.from_date': 'From Date',

    'team-member-payroll-adjustment.label.from__thru_date': 'From thru date',
    'team-member-payroll-adjustment.label.to__thru_date': 'To thru date',
    'team-member-payroll-adjustment.label.thru_date': 'Thru Date',

    'team-member-payroll-adjustment.label.payroll_adjustment_type_name': 'Payroll Adjustment Type',

    'team-member-payroll-adjustment.label.adjustment_label': 'Adjustment Label',

    'team-member-payroll-adjustment.label.is_taxable': 'Is Taxable',

    'team-member-payroll-adjustment.label.is_third_party': 'Is Third Party',

    'team-member-payroll-adjustment.label.title': 'Title',

    'team-member-payroll-adjustment.label.name': 'Name',

    'team-member-payroll-adjustment.label.first_name': 'First Name',

    'team-member-payroll-adjustment.label.last_name': 'Last Name',

    'team-member-payroll-adjustment.label.entity_name': 'Contact',

    'team-member-payroll-adjustment.label.address': 'Address',

    'team-member-payroll-adjustment.label.address_line_1': 'Address Line 1',

    'team-member-payroll-adjustment.label.address_line_2': 'Address Line 2',

    'team-member-payroll-adjustment.label.address_line_3': 'Address Line 3',

    'team-member-payroll-adjustment.label.province': 'Province',

    'team-member-payroll-adjustment.label.postal_code': 'Postal Code',

    'team-member-payroll-adjustment.label.country_name': 'Country',

    'team-member-payroll-adjustment.label.email_address': 'Email Address',

    'team-member-payroll-adjustment.label.telephone': 'Telephone',

    'team-member-payroll-adjustment.label.mobile': 'Mobile',

    'team-member-payroll-adjustment.label.entity_name': 'Contact',
    'team-member-payroll-adjustment.label.account_number': 'Account Number',
    'team-member-payroll-adjustment.label.instructions': 'Instructions',

    'team-member-payroll-adjustment.placeholder.search_entity': 'Search for contact...',
    'team-member-payroll-adjustment.placeholder.account_number': 'Optional account number',
    'team-member-payroll-adjustment.placeholder.instructions': 'Optional instructions for this payment',

    'team-member-payroll-adjustment.label.memo': 'Memo',

    'team-member-payroll-adjustment.label.currency_name': 'Currency',

    'team-member-payroll-adjustment.label.from__currency_amount_in_cents': 'From Amount',
    'team-member-payroll-adjustment.label.to__currency_amount_in_cents': 'To Amount',
    'team-member-payroll-adjustment.label.currency_amount_in_cents': 'Currency Amount',

    'team-member-payroll-adjustment.label.from__base_amount_in_cents': 'From base amount in cents',
    'team-member-payroll-adjustment.label.to__base_amount_in_cents': 'To base amount in cents',
    'team-member-payroll-adjustment.label.base_amount_in_cents': 'Base Amount In Cents',

    'team-member-payroll-adjustment.label.from__system_amount_in_cents': 'From system amount in cents',
    'team-member-payroll-adjustment.label.to__system_amount_in_cents': 'To system amount in cents',
    'team-member-payroll-adjustment.label.system_amount_in_cents': 'System Amount In Cents',

    'team-member-payroll-adjustment.label.from__created_at': 'From created at',
    'team-member-payroll-adjustment.label.to__created_at': 'To created at',
    'team-member-payroll-adjustment.label.created_at': 'Created At',

    'team-member-payroll-adjustment.label.from__updated_at': 'From updated at',
    'team-member-payroll-adjustment.label.to__updated_at': 'To updated at',
    'team-member-payroll-adjustment.label.updated_at': 'Updated At',

    'team-member-payroll-adjustment.label.from__deleted_at': 'From deleted at',
    'team-member-payroll-adjustment.label.to__deleted_at': 'To deleted at',
    'team-member-payroll-adjustment.label.deleted_at': 'Deleted At',

    'team-member-payroll-adjustment.label.status': 'Status',

    'team-member-payroll-adjustment.sort.field_label': 'Field',
    'team-member-payroll-adjustment.sort.direction_label': 'Direction',
    'team-member-payroll-adjustment.sort.direction_ascending': 'Ascending',
    'team-member-payroll-adjustment.sort.direction_descending': 'Descending',

    'team-member-payroll-adjustment.modal.title.team_member_payroll_adjustment_archive': 'Archive Payroll Adjustment',
    'team-member-payroll-adjustment.modal.title.team_member_payroll_adjustment_delete_permanently': 'Delete Payroll Adjustment',
    'team-member-payroll-adjustment.modal.title.team_member_payroll_adjustment_restore': 'Restore Payroll Adjustment',

    'team-member-payroll-adjustment.modal.message.team_member_payroll_adjustment_archive':
        'Are you sure that you want to move this payroll adjustment to the archive? | Are you sure that you want to move these payroll adjustments to the archive?',
    'team-member-payroll-adjustment.modal.message.team_member_payroll_adjustment_delete_permanently':
        'Are you sure that you want to permanently delete this payroll adjustment? This action cannot be undone. | Are you sure that you want to permanently delete these payroll adjustments? This action cannot be undone.',
    'team-member-payroll-adjustment.modal.message.team_member_payroll_adjustment_restore': 'Are you sure that you want to restore this payroll adjustment? | Are you sure that you want to restore these payroll adjustments?',

    'team-member-payroll-adjustment.success.message.team_member_payroll_adjustment_created': 'Your payroll adjustment has been created',
    'team-member-payroll-adjustment.success.message.team_member_payroll_adjustment_updated': 'Your payroll adjustment has been updated',
    'team-member-payroll-adjustment.success.message.team_member_payroll_adjustment_restored': 'Your payroll adjustment has been restored | All selected payroll adjustments were restored',
    'team-member-payroll-adjustment.success.message.team_member_payroll_adjustment_deleted': 'Your payroll adjustment has been permanently deleted | All selected payroll adjustments were permanently deleted',
    'team-member-payroll-adjustment.success.message.archived_team_member_payroll_adjustments': 'Your payroll adjustment was moved to the archive | All selected payroll adjustments were moved to the archive',

    'team-member-payroll-adjustment.error.message.archived_team_member_payroll_adjustments': 'This payroll adjustment was already moved to the archive | These payroll adjustments were already moved to the archive',
    'team-member-payroll-adjustment.error.message.team_member_payroll_adjustment_deleted': 'This payroll adjustment was already permanently deleted | These payroll adjustments were already permanently deleted',
    'team-member-payroll-adjustment.error.message.team_member_payroll_adjustment_restored': 'This payroll adjustment was already restored | These payroll adjustments were already restored',
    'team-member-payroll-adjustment.error.message.error_loading_page': 'Sorry, there was an error loading payroll adjustment.| Sorry, there was an error loading payroll adjustments.',

    'team-member-payroll-adjustment.message.search.no_archived_team_member_payroll_adjustments': "You haven't archived any team any member any payroll any adjustments as yet.",
};
